import React from 'react';
import { motion } from 'framer-motion';
export const ResultsSection = () => {
  const results = ['https://uploadthingy.s3.us-west-1.amazonaws.com/wMS9trReAgobjJrUWcS3Ud/IMG_4323.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/wB6JmdtmouyfVjAd9Ffv6C/IMG_4321.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hyHqZCTsPLCdoEjJr2SfPG/IMG_4315.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/1Gco8bhs9GYzyttsigNQ7m/IMG_4340.jpg'];
  return <section className="w-full py-8 sm:py-12 px-4 bg-white" data-id="element-209">
      <div className="container mx-auto max-w-4xl" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-8" data-id="element-211">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-3" data-id="element-212">
            Resultados Reales de Personas Reales
          </h2>
          <div className="h-1 w-20 bg-[#7A3EFF] mx-auto rounded-full" data-id="element-213" />
        </motion.div>
        <div className="grid grid-cols-2 gap-3 sm:gap-4 max-w-3xl mx-auto" data-id="element-214">
          {results.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="relative rounded-xl overflow-hidden border-2 border-[#7A3EFF] shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-215">
              <img src={image} alt={`Resultado real ${index + 1}`} className="w-full h-full object-cover aspect-square" data-id="element-216" />
            </motion.div>)}
        </div>
      </div>
    </section>;
};